import React, { useState } from "react";
import "./styles.css";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowCircleLeft } from "react-icons/fa";
import LogotipoRadaria from "../../assets/images/logotipos/RADARIA-LOGOTIPO04.png";
import { validateFormSendEmail } from "./validateFormResetPwd";
import Loading from "../../components/Loading/Loading";
import { sendEmailForgotPassword } from "../../services/rest/users/resertPassword";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";

const SendEmailForNewPassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    delete errors[name];
    setEmail({ [name]: value });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const validateEmail = validateFormSendEmail(email);
      if (Object.keys(validateEmail).length !== 0) {
        setErrors(validateEmail);
        return;
      }
      const response = await sendEmailForgotPassword(email);
      setLoading(false);
      toast.success(response?.message ?? "Verifica tu correo.", {
        duration: 10000,
      });
      navigate("/auth");
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(message ?? "Algo saló mal. \n Intentalo más tarde.", {
        duration: 10000,
      });
    }
  };

  return (
    <div className="wrapper-forgotPassword">
      <Loading loading={loading} />
      <section className="wrapper-form">
        <div className="d-flex justify-content-between align-items-center">
          <Link
            to="/auth"
            className="d-flex gap-3 justify-content-between align-items-center"
          >
            <FaArrowCircleLeft className="text-white fs-1" />
            <img src={LogotipoRadaria} alt="" width={200} height={40} />
          </Link>
        </div>
        <div className="form-wrapper">
          <h2 className="text-white text-center">Recuperar Contraseña</h2>
          <form
            className="d-flex flex-column align-items-center justify-content-center "
            onSubmit={handleSubmit}
          >
            <label className="text-white form-label">Correo Electrónico:</label>
            <input
              type="email"
              name="email"
              placeholder="correo@ejemplo.com"
              className="form-control text-white"
              onChange={handleChange}
              required
            />
            <button type="submit" className="btn btn-primary mt-3">
              Enviar
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default SendEmailForNewPassword;
